import React from "react";

import "./list.css";
// Should we rename this to HeaderList?
export const List = (props: React.HTMLProps<HTMLUListElement>) => {
	const { children, ...rest } = props;

	return (
		<ul className="list" {...rest}>
			{children}
		</ul>
	);
};

List.displayName = "List";
